import {CircularProgress} from '@material-ui/core'
import {Alert} from '@material-ui/lab'
import {Root, Title} from './styled'
import {BusyBackdrop, CreateButton, Grid, TableTop} from './styled'

export type ManagementTemplateProps = {
  children: React.ReactNode
  style?: any
  busy: boolean
  title: string
  createButtonTitle?: string
  onCreateClick?: () => void
  error?: Error | null
}

const ManagementTemplate: React.FC<ManagementTemplateProps> = ({
  children,
  style,
  busy,
  title,
  createButtonTitle,
  onCreateClick,
  error,
}: ManagementTemplateProps) => {
  return (
    <Root style={{...style}}>
      <TableTop container spacing={3} alignItems="center">
        <Grid container item xs={6}>
          <Title>{title}</Title>
        </Grid>
        {createButtonTitle && onCreateClick && (
          <Grid container item xs={6} justify="flex-end">
            <CreateButton onClick={onCreateClick}>{createButtonTitle}</CreateButton>
          </Grid>
        )}
      </TableTop>
      {error && <Alert severity="error">{error.message}</Alert>}
      {children}
      <BusyBackdrop open={busy}>
        <CircularProgress color="inherit" />
      </BusyBackdrop>
    </Root>
  )
}

export default ManagementTemplate
